// Bilangan acak dan pengacakan urutan.
export const R=(a,b)=>Math.floor(Math.random()*(b-a+1))+a;
export const pick=a=>a[Math.floor(Math.random()*a.length)];
export const coin=()=>Math.random()<0.5;
export function shuffle(a){a=[...a];for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;}
